import React from 'react';
import { connect } from 'react-redux';
import {
  toggle_menu,
  refresh,
  setting_show,
  change_settings,
  push_current,
  toggle_info,
  open_close_file,
  toggle_terminal,
  fire_command,
} from '../Redux/actions';
import moment from 'moment';
import { history } from '../Redux/store';
import Modal from '../Components/Modal';
import Menu from '../Components/Menu';
import Settings from '../Components/Settings';
import Information from '../Components/Information';
import '../Style/desktop.css';
import { desktop_card } from '../Utils/constants';

function App({
  toggle_menu,
  toggle_terminal,
  pages,
  refresh,
  setting_show,
  change_settings,
  push_current,
  toggle_info,
  open_close_file,
  fire_command,
}) {
  return (
    <React.Fragment>
      <div className="desktop">
        <div
          style={
            pages.menu.show ||
            pages.settings.show ||
            pages.current.show ||
            pages.info_show
              ? { display: 'none' }
              : { display: 'block' }
          }
          className="desktop_icons"
        >
          {pages.desktop.folders.map((dir, i) => (
            <div
              key={i}
              onDoubleClick={() => {
                dir.action === 'info'
                  ? toggle_info(dir.data)
                  : dir.action === 'carousel'
                  ? push_current(true, {
                      type: 'dir',
                      header: dir.name,
                      files: dir.data,
                      show: true,
                    })
                  : history.push(dir.data);
              }}
              className="folders"
            >
              {dir.icon}
              <p className="folders folder_name">{dir.name}</p>
            </div>
          ))}
        </div>
        <div
          className="card-holder"
          style={
            pages.menu.show ||
            pages.settings.show ||
            pages.current.show ||
            pages.info_show
              ? { display: 'none' }
              : { display: 'contents', width: '90%' }
          }
        >
          {desktop_card.map((info, i) =>
            i === 0 ? (
              <div key={i} className={`desktop-card skew-${(i % 2) + 1}`}>
                <h2>{info.name}</h2>
                <p>{info.sub}</p>
              </div>
            ) : i === 1 ? (
              <div key={i} className={`desktop-card skew-${(i % 2) + 1}`}>
                {info.map((inform, j) => (
                  <div key={j} style={{ margin: '1%' }}>
                    <h3>{inform.header}</h3>
                    <ol>
                      {inform.sub.map((sub, k) => (
                        <li key={k}>{sub}</li>
                      ))}
                    </ol>
                  </div>
                ))}
              </div>
            ) : (
              <div key={i} className={`desktop-card skew-${(i % 2) + 1}`}>
                <h4>{info.header}</h4>
                <ol>
                  {info.sub.map((sub, k) => (
                    <li key={k}>{sub}</li>
                  ))}
                </ol>
              </div>
            )
          )}
        </div>
        <Information
          data={pages.info}
          show={pages.info_show}
          toggle={toggle_info}
        />
        <Menu
          menu={pages.menu}
          toggle_terminal={toggle_terminal}
          toggle={toggle_menu}
          fire_command={fire_command}
          terminal={pages.terminal}
        />
        <Settings
          settings={pages.settings}
          setting_show={setting_show}
          change_settings={change_settings}
        />
        <Modal
          file={pages.file}
          open_close_file={open_close_file}
          push_current={push_current}
          current={pages.current}
        />
      </div>
      <div className="taskbar">
        <div onClick={(e) => toggle_menu()} className="init_button">
          <i className="fi-rr-grid"></i>
        </div>
        <div className="utility">
          <span className="utility_date_info">
            {navigator.onLine ? (
              <i className="fi-rr-world"></i>
            ) : (
              <i className="fi-rr-exclamation"></i>
            )}
          </span>
          <span className="utility_date_info">
            <i onClick={() => refresh()} className="fi-rr-refresh"></i>
          </span>
          <span className="utility_date_info">
            <i
              onClick={() => setting_show(true)}
              className="fi-rr-settings-sliders"
            ></i>
          </span>
          <span className="utility_date_info">
            <a href="https://github.com/yashdatir/">
              <i className="fi-rr-user"></i>
            </a>
          </span>
          <span className="utility_date_info">
            <a href="https://yashdatir.github.io/My-Games/">
              <i className="fi-rr-tennis"></i>
            </a>
          </span>
          <span className="utility_date_info">
            <span className="date">
              <p>
                {moment(pages.settings.localization.date).format(
                  pages.settings.localization.date_format
                )}
              </p>
            </span>
            <span className="time">
              <p>
                {moment(pages.settings.localization.date).format(
                  pages.settings.localization.time_format
                )}
              </p>
            </span>
          </span>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = ({ pages }) => {
  return { pages };
};

export default connect(mapStateToProps, {
  toggle_menu,
  refresh,
  setting_show,
  change_settings,
  push_current,
  toggle_info,
  open_close_file,
  toggle_terminal,
  fire_command,
})(App);
